"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var server_1 = require("react-dom/server");
var useEffect = React.useEffect, useMemo = React.useMemo, useRef = React.useRef;
exports.default = (function (_a) {
    var button = _a.button, children = _a.children, additionalClasses = _a.additionalClasses;
    var ref = useRef(null);
    // create a random ID to identify the tooltip in the DOM
    var tooltipId = useMemo(function () { return new Date().getTime(); }, []);
    var closeTooltipFnName = "closeTooltip".concat(tooltipId);
    useEffect(function () {
        var tooltip = new Foundation.Tooltip($(ref.current));
        window[closeTooltipFnName] = function () { return tooltip.hide(); };
        return function () {
            tooltip.destroy();
        };
    }, []);
    // foundtion tooltip requires HTML as a string attribute 'title'
    var title = useMemo(function () {
        // add a close button to the content
        var childrenWithButton = (React.createElement("div", { className: 'position-relative' },
            React.createElement("a", { href: "javascript:".concat(closeTooltipFnName, "()"), className: 'position-absolute top-0 right-0' },
                React.createElement("i", { className: 'ss-delete text-gray lh1', style: { fontSize: 26 } })),
            children));
        return (0, server_1.renderToStaticMarkup)(childrenWithButton);
    }, []);
    return (React.createElement("div", { "data-tooltip": true, "data-allow-html": true, "data-disable-hover": true, className: additionalClasses, title: title, ref: ref }, button));
});
